import React from 'react'
import Head from 'next/head'
import { APP_CONFIG } from '../../Config'
import {cityStateToUrl} from "../../helpers/auctions"


const Schema = ({auction}) => {
    const cityStateUrl = cityStateToUrl(auction)

    const eventSchemaData = {
        "@context": "https://www.schema.org",
        "@type": "Event",
        "name": "Online Auction",
        "url": `${APP_CONFIG.APP_URL}/auctions/${cityStateUrl}/${auction?.auction_id}`,
        "description": `Live online self storage auction in ${auction?.city}, ${auction?.state}.`,
        "startDate": auction?.active_date?.utc?.datetime.replace(' ', 'T'),
        "endDate": auction?.expire_date?.utc?.datetime.replace(' ', 'T'),
        "location": {
            "@type": "Place",
            "name": auction?.facility_name,
            "address": {
                "@type": "PostalAddress",
                "streetAddress": auction?.address,
                "addressLocality": auction?.city,
                "addressRegion": auction?.state,
                "postalCode": auction?.zipcode,
                "addressCountry": auction?.facility?.country
            }
        },
        "offers": {
            "@type": "Offer",
            "description": `${auction?.unit_width} x ${auction?.unit_length} Storage Unit Auction`,
            "url": `${APP_CONFIG.APP_URL}/auctions/${cityStateUrl}/${auction?.auction_id}`,
            "price": auction?.current_bid?.formatted
        }
    }

    const productSchemaData = {
        "@context": "https://schema.org/",
        "@type": "Product",
        "name": `Online Storage Unit Auction - ${auction?.city}, ${auction?.state}`,
        "image": auction?.image?.image_path?.replace('thumb', 'giant'),
        "description": `Approx. Size: ${auction?.unit_width} x ${auction?.unit_length}, ` +
            `Unit Appears to Contain: ${auction?.categories?.map((c) => c.category_name).join(', ')}`,
        "brand": {
            "@type": "Brand",
                "name": "StorageTreasures"
        },
        "sku": auction?.auction_id,
            "offers": {
            "@type": "AggregateOffer",
                "url": `${APP_CONFIG.APP_URL}/auctions/${cityStateUrl}/${auction?.auction_id}`,
                "priceCurrency": auction?.facility?.currency_code,
                "lowPrice": auction?.current_bid?.formatted,
                "offerCount": auction?.total_bids
        }
    }


    return (
        <Head>
            <script
                type="application/ld+json"
                dangerouslySetInnerHTML={{ __html: JSON.stringify(eventSchemaData) }}
            />
            <script
                type="application/ld+json"
                dangerouslySetInnerHTML={{ __html: JSON.stringify(productSchemaData) }}
            />
        </Head>
    )
}

export default Schema
